module.exports = {
	Normal: 0,
	Fish_Player8: 1,
	Unknown: 99
}